
import { Component, Prop, Vue } from "vue-property-decorator";

interface BreadcrumbItem {
  text: string;
  to?: any;
  disabled?: boolean;
}

@Component
export default class BreadcrumbTrail extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: BreadcrumbItem[];

  get themeClass(): string {
    return this.$store.state.lightDarkMode === "dark" ? "breadcrumb-dark" : "breadcrumb-light";
  }
}
